// MOCK: WizardInitResponseDto
// Activado cuando environment.useMocksInstructivoEmbarque = true
import { WizardInitResponseDto } from '@opb-workspace/shared';

export const MOCK_WIZARD_INIT_617: WizardInitResponseDto = {
    voyageId: 617,
    voyageNumber: '2024W43-CORS',
    vesselId: 12,
    vesselName: 'MSC CASSANDRE',
    carrierId: 3,
    carrierName: 'HAPAG',
    portOfLoadingId: 45,
    portOfLoadingName: 'VALPARAISO',
    portOfDischargeId: 112,
    portOfDischargeName: 'ROTTERDAM',
    voyageCallLoadingId: 1045,
    voyageCallDischargeId: 1112,
    terminalPol: 'STI',
    etd: '2024-11-04',
    eta: '2024-12-03',
    cutOffDocumental: '2024-11-01',
    cutOffFisico: '2024-10-31',
    serviceType: 'Liner',
    transitDays: 29,
    isTerminalAvailable: true,
    isCutOffAvailable: true,
    billOfLadingIssuer: 'HAPAG',
    countryOfFinalDestination: 'ALEMANIA',
    stackingDescription:
        'Desde Viernes 2 de Noviembre a las 15:30 hrs hasta el Sabado 3 de Noviembre a las 22:00 hrs',
    availableBookings: [
        {
            bookingId: 4588221,
            bookingNumber: 'OPB-2024-001221',
            carrierBookingNumber: 'MSC-BCN-884421',
            customerId: 77,
            customerName: 'Frutexpo SpA',
            shipperName: 'Frutexpo Export SPA',
            containerCount: 2,
            packageCount: 48,
            hasActiveShippingInstruction: false,
        },
        {
            bookingId: 4588305,
            bookingNumber: 'OPB-2024-001305',
            carrierBookingNumber: 'MSC-BCN-884530',
            customerId: 82,
            customerName: 'Exportaciones Del Sur Ltda.',
            shipperName: 'EDS Shipper S.A.',
            containerCount: 0,
            packageCount: 24,
            hasActiveShippingInstruction: false,
        },
        {
            bookingId: 4588410,
            bookingNumber: 'OPB-2024-001410',
            carrierBookingNumber: undefined,
            customerId: 90,
            customerName: 'Agrícola San Lorenzo S.A.',
            shipperName: 'San Lorenzo Fruits',
            containerCount: 1,
            packageCount: 0,
            hasActiveShippingInstruction: false,
        },
    ],
};

// Variante sin cutoffs — activa la rama de advertencia en Step 1
export const MOCK_WIZARD_INIT_618_NO_CUTOFF: WizardInitResponseDto = {
    voyageId: 618,
    voyageNumber: '2024W44-MAE',
    vesselId: 19,
    vesselName: 'MAERSK BAYETE',
    carrierId: 7,
    carrierName: 'Maersk',
    portOfLoadingId: 45,
    portOfLoadingName: 'Coronel',
    portOfDischargeId: 88,
    portOfDischargeName: 'Hamburgo',
    terminalPol: undefined,
    etd: '2024-11-10',
    eta: undefined,
    cutOffDocumental: undefined,
    cutOffFisico: undefined,
    serviceType: 'Charter',
    transitDays: undefined,
    isTerminalAvailable: false,
    isCutOffAvailable: false,
    availableBookings: [],
};
